import { take } from 'lodash'
import types from '@redux/types/basic/layout'

const DEFAULT = {
  current: -1,
  stack: []
}
// TODO: max 50
function pushToStack(state, item) {
  const { current, stack } = state
  const newIndex = current + 1
  const newStack = [...take(stack, newIndex), item]
  return {
    current: newIndex,
    stack: newStack
  }
}
// TODO: real replace?
function replaceCurrent(state, item) {
  const { current, stack } = state
  const newStack = [...take(stack, current), item]
  return {
    current,
    stack: newStack
  }
}

export default function reducer(state = DEFAULT, { type, payload }) {
  const { stack, current } = state
  switch (type) {
    case types.PUSH_CRUMB_LIST: {
      const currentItem = stack[current] || {
        list: []
      }
      const newItem = {
        key: payload.key,
        list: [...currentItem.list, ...payload.list]
      }
      return pushToStack(state, newItem)
    }
    case types.REPLACE_CRUMB_LIST:
      const currentItem = stack[current] || {
        list: []
      }
      const newItem = {
        key: payload.key,
        list: [
          ...take(currentItem.list, currentItem.list.length - 1),
          ...payload.list
        ]
      }
      return replaceCurrent(state, newItem)
    case types.RESET_CRUMB_LIST:
      return pushToStack(state, {
        key: payload.key,
        list: payload.list
      })
    case types.REDO_CRUMB_LIST:
      return {
        ...state,
        current:
          current + payload >= stack.length
            ? stack.length - 1
            : current + payload
      }
    case types.UNDO_CRUMB_LIST:
      return {
        ...state,
        current: current - payload < 0 ? 0 : current - payload
      }
    case types.INIT_CRUMB_LIST:
      return payload

    default:
      return state
  }
}
